// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__bip4Y"};